import { isPlatformServer } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuctionDownloadedService } from '@core/services/auction-downloaded.service';
import { AuthService } from '@core/services/auth.service';
import { ModalUtilsService } from '@core/services/modal-utils.service';
import { faBell, faEnvelope, faHeart, faUser, } from '@fortawesome/free-regular-svg-icons';
import { faCartPlus, faChevronDown, faSearch, faSignOutAlt, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { ILanguage } from '@shared/interfaces/language.interface';
import { FilterStatus } from '@shared/interfaces/search.interface';
import { LanguageService } from '@shared/services/language.service';
import { MessageService } from '@shared/services/message.service';
import { RedirectService } from '@shared/services/redirect.service';
import { SearchService } from '@shared/services/search.service';
import { NotificationService } from 'src/app/account/services/notification.service';
import { ContactsDialogComponent } from 'src/app/article/components/dialogs/contacts-dialog/contacts-dialog.component';
import { AccountDialogComponent } from 'src/app/login/components/account-dialog/account-dialog.component';
import { ActivateAccountPopupComponent } from 'src/app/login/pages/activate-account-popup/activate-account-popup.component';
import { LoginService } from 'src/app/login/services/login.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  faHeart = faHeart;
  faBell = faBell;
  faEnvelope = faEnvelope;
  faUser = faUser;
  faSearch = faSearch;
  faSlidersH = faSlidersH;
  faChevronDown = faChevronDown;
  faSignOutAlt = faSignOutAlt;
  faCartPlus = faCartPlus;

  public isMenuCollapsed = true;

  imgCountry: string = '/assets/img/it.png';

  @ViewChild('searchInputHeader') searchInputHeader: ElementRef;
  @ViewChild('accountDropdown') accountDropdown;
  @ViewChild('accountMobileDropdown') accountMobileDropdown;

  selectedIdAuctionType = -1;
  selectedStringAuctionType = 'IDS_ALL';
  searchText: string = '';
  onlyNew: boolean = false;
  onlyExpiring: boolean = false;
  onlyArriving: boolean = false;
  onlySigned: boolean = false;
  detailStore: boolean = false;
  detailWorn: boolean = false;

  constructor(
    public authService: AuthService,
    public searchService: SearchService,
    private loginService: LoginService,
    private modalUtils: ModalUtilsService,
    private router: Router,
    private redirectService: RedirectService,
    private translate: TranslateService,
    public notificationService: NotificationService,
    public languageService: LanguageService,
    private auctionDownloadedService: AuctionDownloadedService,
    public messageService: MessageService,
	@Inject(PLATFORM_ID) private _platformId: Object
  ) {
  }

  ngOnInit(): void {
    if (isPlatformServer(this._platformId)) {
      this.imgCountry = '/assets/img/it.png';
      return;
    }

    if (localStorage.getItem('langCode') != null) {
      this.imgCountry = '/assets/img/'+localStorage.getItem('langCode')+'.png';
    } else {
      if (window.navigator.language.toLowerCase() == 'it-it' || window.navigator.language.toLowerCase() == 'it') {
        this.imgCountry = '/assets/img/it.png';
      } else {
        this.imgCountry = '/assets/img/en.png';
      }
    }
  }

  setFlag(lang: string) {
    this.imgCountry = '/assets/img/'+lang+'.png';
  }


  goToHome() {
    this.isMenuCollapsed = true;
    this.redirectService.redirect('home');
  }

  setAuctionType(id: number) {
    this.selectedIdAuctionType = id;
    const selectedAuctionType = this.searchService.auctionTypeList.find(item => item.key === id);
    this.selectedStringAuctionType = selectedAuctionType.value;
  }

  search() {
    this.auctionDownloadedService.scrollPosition = 0;
    this.searchInputHeader.nativeElement.blur();

    let idDetail: number | null = null;
    if(this.detailStore && !this.detailWorn) {
      idDetail = 1;
    } else if(this.detailWorn && !this.detailStore) {
      idDetail = 2;
    }

    let auctionStatus = FilterStatus.All;
    let searchRoute = 'search-result';
    if(this.searchText == '' && this.selectedIdAuctionType == -1 && !this.onlyNew && !this.onlyExpiring && !this.onlyArriving) {
      if(this.onlySigned && !this.detailStore && !this.detailWorn) {
        searchRoute = 'search-result-signed';
        auctionStatus = FilterStatus.OnlyActive;
      } else if(!this.onlySigned && this.detailStore && !this.detailWorn) {
        searchRoute = 'search-result-store';
        auctionStatus = FilterStatus.OnlyActive;
      } else if(!this.onlySigned && !this.detailStore && this.detailWorn) {
        searchRoute = 'search-result-worn';
        auctionStatus = FilterStatus.OnlyActive;
      } else if(!this.onlySigned && !this.detailStore && !this.detailWorn) {
        searchRoute = 'search-result-all';
        auctionStatus = FilterStatus.OnlyActive;
      }
    }

    this.searchService.setFilters(
      searchRoute,
      {
        idLanguage: this.languageService.userSelectedLanguage.idLanguage,
        searchText: this.searchText,
        idAuctionType: this.selectedIdAuctionType,
        idDetail: idDetail,
        onlySigned: this.onlySigned,
        idSport: null,
        idCompetition: null,
        idTeam: null,
        onlyNew: this.onlyNew,
        onlyExpiring: this.onlyExpiring,
        onlyArriving: this.onlyArriving,
        auctionStatus: auctionStatus,
        idEntity: null,
        idCampaign: null,
        idPromoter: null,
        idActiveAuction: null,
        idTagList: [],
        orderBy: 'evidence',
        orderDirection: 'desc'
      }
    );
  }

  resetHeaderFilters() {
    this.searchText = '';
    this.setAuctionType(-1);
    this.onlyNew = false;
    this.onlyExpiring = false;
    this.onlyArriving = false;
    this.onlySigned = false;
    this.detailStore = false;
    this.detailWorn = false;
  }

  searchAllAuction() {
    this.auctionDownloadedService.scrollPosition = 0;
    this.resetHeaderFilters();
    this.search();
  }

  searchMatchWorn() {
    this.auctionDownloadedService.scrollPosition = 0;
    this.resetHeaderFilters();
    this.searchService.setFilters(
      'search-result-worn',
      {
        idLanguage: this.languageService.userSelectedLanguage.idLanguage,
        searchText: '',
        idAuctionType: -1,
        idDetail: 2,
        onlySigned: false,
        idSport: null,
        idCompetition: null,
        idTeam: null,
        onlyNew: false,
        onlyExpiring: false,
        onlyArriving: false,
        auctionStatus: FilterStatus.OnlyActive,
        idEntity: null,
        idCampaign: null,
        idPromoter: null,
        idActiveAuction: null,
        idTagList: [],
        orderBy: 'evidence',
        orderDirection: 'desc'
      }
    );
  }

  searchStore() {
    this.auctionDownloadedService.scrollPosition = 0;
    this.resetHeaderFilters();
    this.searchService.setFilters(
      'search-result-store',
      {
        idLanguage: this.languageService.userSelectedLanguage.idLanguage,
        searchText: '',
        idAuctionType: -1,
        idDetail: 1,
        onlySigned: false,
        idSport: null,
        idCompetition: null,
        idTeam: null,
        onlyNew: false,
        onlyExpiring: false,
        onlyArriving: false,
        auctionStatus: FilterStatus.OnlyActive,
        idEntity: null,
        idCampaign: null,
        idPromoter: null,
        idActiveAuction: null,
        idTagList: [],
        orderBy: 'evidence',
        orderDirection: 'desc'
      }
    );
  }

  searchSigned() {
    this.auctionDownloadedService.scrollPosition = 0;
    this.resetHeaderFilters();
    this.searchService.setFilters(
      'search-result-signed',
      {
        idLanguage: this.languageService.userSelectedLanguage.idLanguage,
        searchText: '',
        idAuctionType: -1,
        idDetail: null,
        onlySigned: true,
        idSport: null,
        idCompetition: null,
        idTeam: null,
        onlyNew: false,
        onlyExpiring: false,
        onlyArriving: false,
        auctionStatus: FilterStatus.OnlyActive,
        idEntity: null,
        idCampaign: null,
        idPromoter: null,
        idActiveAuction: null,
        idTagList: [],
        orderBy: 'evidence',
        orderDirection: 'desc'
      }
    );
  }

  onIconPressed(nextPageRoute: string) {
    if(this.authService.isAuthenticated()) {
      if(nextPageRoute == 'account' && this.authService.userLogged.idProfile == 1) {
        nextPageRoute = 'admin';
      }
        this.redirectService.redirect(nextPageRoute);
    } else {
      if(nextPageRoute == 'account/messages') {
        const modal = this.modalUtils.openModal(ContactsDialogComponent, { size: 'lg', keyboard: false });
        modal.componentInstance.onClickIconMessageHeader = '/about-us';
      } else {
        if(this.authService.authResult == -2) {
          this.modalUtils.openModal(ActivateAccountPopupComponent, { size: 'md', keyboard: false });
        } else {
          const ref = this.modalUtils.openModal(AccountDialogComponent, { size: 'md', keyboard: false });
          ref.componentInstance.nextPageRoute = nextPageRoute;
        }
      }
    }
  }

  onAccountPressed(nextPageRoute: string) {
    if(this.authService.isAuthenticated()) {
      if(nextPageRoute == 'account' && this.authService.userLogged.idProfile == 1) {
        nextPageRoute = 'admin';
      }
    } else {
      this.accountDropdown.close();
      this.accountMobileDropdown.close();
        if(this.authService.authResult == -2) {
          this.modalUtils.openModal(ActivateAccountPopupComponent, { size: 'md', keyboard: false });
        } else {
          const ref = this.modalUtils.openModal(AccountDialogComponent, { size: 'md', keyboard: false });
          ref.componentInstance.nextPageRoute = nextPageRoute;
        }
      }
  }

  logout() {
    if(this.authService.isAuthenticated() || this.authService.isToActivate()) {
      this.loginService.logout().subscribe(() => {
        this.authService.logout();
        this.notificationService.unreadNotificationsCount = 0;
        this.messageService.unreadMessagesCount = 0;
        this.messageService.clearRefreshTimer();
        this.redirectService.redirect('home');
      });
    }
  }

  changeLanguages(lang: ILanguage) {
    localStorage.setItem('langId', (lang.idLanguage).toString());
    localStorage.setItem('langCode', lang.code);

    this.translate.setDefaultLang(localStorage.getItem('langCode'));
    this.translate.use(localStorage.getItem('langCode'));
    this.languageService.userSelectedLanguage = {
      idLanguage: parseInt(localStorage.getItem('langId')),
      code: localStorage.getItem('langCode'),
      description: ""
    };
    this.searchService.filters.idLanguage = this.languageService.userSelectedLanguage.idLanguage;
    let urlParts = this.router.url.split('/');
    if (this.translate.getLangs().includes(urlParts[1])) {
      urlParts.splice(1, 1);
    }
    this.setFlag(lang.code);
    this.redirectService.redirect(decodeURIComponent(urlParts.join('/')), 301, lang.code);

    this.router.navigate([decodeURIComponent(urlParts.join('/'))]);

  }
}
